<template>
  <div class="main-box">
    <el-form class="form-inline" :inline="true" size="small">
      <el-form-item label="">
        <el-select v-model="search.type" placeholder="请选择类型" size="small" clearable @change="handleSearch">
          <el-option label="门店充值" value="1"></el-option>
          <el-option label="下单抵扣" value="3"></el-option>
          <el-option label="订单退款" value="4"></el-option>
          <el-option label="门店退款" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入名称" size="small" clearable>
          <el-button slot="append" class="iv-search" size="small" type="primary" @click="handleSearch">搜索</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table
        :data="tableData"
        ref="rfTable"
        style="width: 100%"
        size="mini">
      <el-table-column
          prop="user_id"
          label="会员ID">
      </el-table-column>
      <el-table-column
          prop="avatar"
          label="头像"
          align="center"
          width="160">
        <template slot-scope="scope">
          <el-avatar :size="40" shape="square" :src="scope.row.avatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
          prop="name"
          label="昵称">
      </el-table-column>
      <el-table-column
          prop="mobile"
          label="手机号">
      </el-table-column>
      <el-table-column
          prop="change_integral"
          label="变动值">
      </el-table-column>
      <el-table-column
          prop="integral"
          label="变动后">
      </el-table-column>
      <el-table-column
          prop="order_sn"
          label="关联订单号">
      </el-table-column>
      <el-table-column
          prop="bill_type"
          label="类型">
      </el-table-column>
      <el-table-column
          prop="remark"
          label="备注">
      </el-table-column>
      <el-table-column
          prop="create_time"
          label="添加时间"
          align="center"
          width="140">
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
  </div>
</template>
<script>

export default {
  components: {},
  data() {
    return {
      info: false,
      source_domain: this.config.SOURCE_DOMAIN,
      search: {
        current_page: 1,
        total: 0,
        limit: 10,
        keywords: '',
        type: '',
        member_id: ''
      },
      tableData: []
    };
  },
  created() {
    if (this.$route.query.member_id) {
      this.search.member_id = parseInt(this.$route.query.member_id)
    }
    this.getList();
  },
  mounted() {
  },
  computed: {},
  methods: {
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords,
        type: that.search.type,
        member_id: that.search.member_id,
      }
      this.$api.member.memberIntegralList(param, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
